import {
  Button,
  Dialog,
  DialogTitle,
  Snackbar,
} from "@mui/material";
import React from "react";
import { useState } from "react";
import AddInventory from "./AddInventory";
import { Stack, Alert } from "@mui/material";

const AddModal = () => {
  const [open, setopen] = useState(false);
  const [Success, setSuccess] = useState(false);
  const [Failure, setFailure] = useState(false);
  const handleModalClick = () => {
    setopen(true);
  };
  const Submitted = () => {
    setSuccess(true);
  };
  const Failed = () => {
    setFailure(true);
  };
  const handleSnack = () => {
    setSuccess(false);
    setFailure(false);
  };
  const handleClose = () => {
    setopen(false);
  };
  return (
    <div>
      <Stack>
        <Snackbar open={Success} autoHideDuration={6000} onClose={handleSnack}>
          <Alert
            onClose={handleSnack}
            severity="success"
            sx={{ background: "green", color: "white" }}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            Car Added Successfully
          </Alert>
        </Snackbar>
        <Snackbar open={Failure} autoHideDuration={6000} onClose={handleSnack}>
          <Alert
            onClose={handleSnack}
            severity="error"
            sx={{ background: "red", color: "white" }}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            Car Addition Failed!!! Please Try Again.
          </Alert>
        </Snackbar>
      </Stack>
      <Button
        variant="contained"
        size="large"
        className="bg-[#1A1A20] text-gray-50 hover:bg-slate-700"
        onClick={handleModalClick}
      >
        Add &nbsp;Car
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        sx={{
          "& .MuiDialog-paper": {
            maxWidth: "800px",
            minWidth: "400px",
            margin: "auto",
            borderRadius: 0,
            padding: "1rem",
          },
        }}
      >
        <DialogTitle sx={{
          textAlign: "center",
          fontSize: "1.5rem",
          fontWeight: "bold",
        }}>Add Car Details</DialogTitle>

        <AddInventory
          AfterSubmit={Submitted}
          AfterFailure={Failed}
          CloseModal={handleClose}
        />
      </Dialog>
    </div>
  );
};

export default AddModal;
